import {
    useLocation,
} from 'react-router-dom'

import {
    useQuery,
} from '@tanstack/react-query'

import preCheckClientViewMutation from './services/pre-check-client-view'
import IdResultView from '../../Components/IdResultView'

const PreCheckView = () => {
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('key')

    const {
        data,
        error,
        isFetching,
    } = useQuery({
        queryKey: ['pre-check-client-view', key],
        queryFn: () => preCheckClientViewMutation({ key }),
        refetchOnWindowFocus: false,
    })

    return (
        <IdResultView
            data={data}
            referenceId={key}
            isFetching={isFetching}
            error={error}
        />
    )
}

export default PreCheckView
